import React from 'react';
import classNames from 'classnames';
import Link from 'components/general/Link/Link';
import LinkProps from 'utils/ts/LinkProps';

const ArticleHeader: React.SFC<ArticleHeaderProps> = ({
  summary,
  category,
  title,
  className,
}) => (
  <header className={classNames('article-header', className)}>
    <div className="article-header__inner">
      {category && (
        <span className="article-header__category">
            {category.to ? (
              <Link to={category.to}>{category.title}</Link>
            ) : <span>{ category.title }</span> }
          </span>
      )}
      <h1
        itemProp="headline"
        className="article-header__title"
        data-test="article-title"
      >
        {title}
      </h1>
      {summary && (
        <div
          itemProp="description"
          className="article-header__summary"
        >
          {summary}
        </div>
      )}
    </div>
  </header>
);

ArticleHeader.defaultProps = {
  className: '',
};

export interface ArticleHeaderProps {
  title: string;
  summary?: string;
  category?: {
    title: string;
    to?: LinkProps;
  };
  className?: string;
}

export default ArticleHeader;

